import Contact from "../../components/contact/Contact";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import About from "../../components/about/About";
import Work from "../../components/work/Work";
// import Review from "../../components/review/Review";
import Navbar from "../../components/navbar/Navbar";

const Home = () => {
  return (
    <>
      <Navbar />
      <Header />
      <About />
      <Work />
      <Contact />
      {/* <Review /> */}
      <Footer />
    </>
  );
};

export default Home;
